import { isNil } from '@antv/util';
/**
 * äºåå³ä¾§æ¥æ¾
 * https://github.com/d3/d3-array/blob/master/src/bisector.js
 */
export default function (getter) {
    /**
     * x: ç®æ å¼
     * lo: èµ·å§ä½ç½®
     * hi: ç»æä½ç½®
     */
    return function (a, x, _lo, _hi) {
        var lo = isNil(_lo) ? 0 : _lo;
        var hi = isNil(_hi) ? a.length : _hi;
        while (lo < hi) {
            var mid = (lo + hi) >>> 1;
            if (getter(a[mid]) > x) {
                hi = mid;
            }
            else {
                lo = mid + 1;
            }
        }
        return lo;
    };
}
//# sourceMappingURL=bisector.js.map